function selectAllAgreements() {

    let selector = document.querySelector('.chbx_selector');
    let selection = document.querySelectorAll('.chbx_selection');

    if (selector && selection) {
        selector.addEventListener('click', () => {
            if (selector.checked === true) {
                selectAll(selection);
            } else {
                deselectAll(selection);
            }
        });

    }

    changeSelector(selection, selector)

}

function selectAll(selection) {
    selection.forEach(chbx => {
        chbx.checked = true;
    });
}

function deselectAll(selection) {
    selection.forEach(chbx => {
        chbx.checked = false;
    });
}

function checkIfSelected(selection, selector) {
    let i = 0
    selection.forEach(chbx => {
        if (chbx.checked === false) {
            selector.checked = false;
        } else {
            i++;
        }
        if (i === selection.length) {
            selector.checked = true;
        }
    });
}

function changeSelector(selection, selector) {
    selection.forEach(chbx => {
        chbx.addEventListener('click', () => {
            let i = 0;
            if (chbx.checked === false) {
                selector.checked = false;
            } else {
                i++;
            }
            checkIfSelected(selection, selector)

        });
    });
}

selectAllAgreements()